<template>
    <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl mt-1">
        <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-xl">
            <Form ref="defaultForm" :validation-schema="getSchema(form.complianceType)">
                <!-- v-slot="{ errors }" {{errors}} -->
                <div class="flex items-center  xl:flex-row flex-col gap-3 mb-3">   
                    <div class="xl:w-1/3 w-full">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="name" v-model="form.name">
                                <span class="text-xs mb-0" :class="labelClass(field.value, errorMessage)">Name</span>
                                <input v-bind="field" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm text-theme-white" :class="inputClass(field.value, errorMessage)" placeholder="OG Kush" type="text">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="complianceProvider" v-model="form.complianceProvider" >
                                <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">Compliance Provider</span>
                                <select v-bind="field" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider"  :class="form.complianceProvider?'text-white':'text-theme-878686'">
                                    <option value="">Select One</option>
                                    <option v-for="(complianceProvider, ind) in complianceProviders" :key="'plant-'+ind" :value="complianceProvider">{{complianceProvider}}</option>
                                </select>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <div class="xl:w-1/3 w-full">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="brand_id" v-model="form.brand_id">
                                <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">Brand</span>
                                <SelectSearchBrand v-bind="field" :value="field.value" :options="brands" placeholder="Select One" class="relative block rounded bg-gray-black w-full border-none text-sm " />
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
                <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="strain" v-model="form.strain" >
                                <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">Plant Type</span>
                                <select v-bind="field" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider"  :class="form.strain?'text-white':'text-theme-878686'">
                                    <option value="">Select One</option>
                                    <option v-for="(plantType, ind) in plantTypes" :key="'plant-'+ind" :value="plantType">{{plantType}}</option>
                                </select>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="complianceType" v-model="form.complianceType" >
                                <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">Compliance Type</span>
                                <select v-model="form.complianceType" class="block rounded bg-gray-black border-none w-full text-sm " :class="form.complianceType?'text-white':'text-theme-878686'">
                                    <option value="" disabled>Select One</option>
                                    <option v-for="(compliance, ind) in complianceList" :value="compliance" :key="'compliance-'+ind">{{compliance}}</option>
                                </select>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper">
                            <Field type="checkbox" v-slot="{field}" name="thc_cbd_value_type" v-model="form.thc_cbd_value_type" value="range" unchecked-value="single">
                                <span class="text-white text-xs font-normal"> THC/CBD Values </span>
                                <label for="item-range" class="flex items-center cursor-pointer ">
                                    <span class="mr-2 text-white text-sm tracking-wider"> Single </span>
                                    <input v-bind="field" value="range" type="checkbox" id="item-range" class="hidden peer">
                                    <div class="w-12 h-6 bg-gray-400 peer-focus:outline-none peer-focus:ring-4 
                                    peer-focus:ring-theme-green dark:peer-focus:ring-theme-green relative rounded-full peer 
                                    dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] 
                                    after:absolute  after:bg-white after:border-gray-400 after:border after:rounded-full 
                                    after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-theme-green"></div>
                                    <span class="ml-2 text-white text-sm text-theme-878686 tracking-wider"> Range </span>
                                </label>
                            </Field>
                        </div>
                    </div>
                </div>
                <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper">
                            <Field v-model="form.sku" v-slot="{field, errors, errorMessage}" name="sku" >
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">SKU</label>
                                <input v-bind="field" placeholder="GJFKD2342" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper">
                            <Field v-model="form.gtin" v-slot="{field, errors, errorMessage}" name="gtin" >
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">GTIN/barcode</label>
                                <input v-bind="field" placeholder="00043423322" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="concentration_unit" v-model="form.concentration_unit" >
                                <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">THC/CBD Unit</span>
                                <select v-bind="field" class="block rounded bg-gray-black w-full border-none text-sm tracking-wider" :class="form.concentration_unit?'text-white':'text-theme-878686'">
                                    <option value="">Select One</option>
                                    <option value="%">%</option>
                                    <option value="mg/g">Mg/g</option>
                                    <option value="mg/ml">Mg/Ml</option>
                                    <option value="mg">Mg</option>
                                    <option value="ml">Ml</option>
                                    <option value="mg/bottle">Mg/bottle</option>
                                    <option value="mg/pack">Mg/pack</option>
                                    <option value="mg/unit">Mg/unit</option>
                                </select>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
                <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="size" v-model="form.size">
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">Variant Size/Name</label>
                                <input v-bind="field" placeholder="3.5g" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <div class="w-full xl:w-1/3">
                        <Field v-slot="{field, errors, errorMessage}" name="weight_equivalent_dry_cannabis" v-model="form.weight_equivalent_dry_cannabis">
                            <label class="text-xs">Cart Equivalency</label>
                            <input v-bind="field" placeholder="1-4" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                            <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                            <div v-else class="text-xs">&nbsp;</div>
                        </Field>
                    </div>
                    <div class="w-full xl:w-1/3">
                        <div class="input-wrapper relative">
                            <Field v-slot="{field, errors, errorMessage}" name="price" v-model="form.price">
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">Cost</label>
                                <span class="absolute top-[33px] left-3">
                                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                                    </svg>
                                </span>
                                <input @wheel.prevent v-model="form.price" placeholder="39.99" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686 pl-6" type="number">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
                <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                    <!-- single thc or range -->
                    <div class="w-full xl:w-1/2">
                        <div class="input-wrapper relative">
                            <Field v-slot="{field, errors, errorMessage}" name="thc" v-model.number="form.thc">
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">THC</label>
                                <div class="flex flex-row rounded bg-gray-black ">
                                    <span class="mt-1 ml-2">{{form.concentration_unit}}</span>
                                    <input v-model.number="form.thc" placeholder="20.5" class="block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                </div>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <!-- cbd is not set or cdb is range -->
                    <div class="w-full xl:w-2/3">
                        <div class="input-wrapper">
                            <label class="text-xs">THC (Range)</label>
                            <div class="flex">
                                <div class="relative w-full">
                                    <Field v-slot="{field, errors, errorMessage}" name="thc_min" v-model.number="form.thc_min">
                                            <div class="flex flex-row rounded bg-gray-black ">
                                                <span class="mt-1 ml-1">{{form.concentration_unit}}</span>
                                                <input v-model.number="form.thc_min" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                            </div>
                                            <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                            <div v-else class="text-xs">&nbsp;</div>
                                        </Field>
                                </div>
                                <span class="flex items-center mx-1">
                                    <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                                    </svg>
                                </span>
                                <div class="relative w-full">
                                    <Field v-slot="{field, errors, errorMessage}" name="thc_max" v-model.number="form.thc_max">
                                        <div class="flex flex-row rounded bg-gray-black ">
                                            <span class="mt-1 ml-1">{{form.concentration_unit}}</span>
                                            <input v-model.number="form.thc_max" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                        </div>
                                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                        <div v-else class="text-xs">&nbsp;</div>
                                    </Field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">

                    <!-- Single CBD or range -->
                    <div  class="w-full xl:w-1/2">
                        <div class="input-wrapper relative">
                            <Field v-slot="{field, errors, errorMessage}" name="cbd" v-model.number="form.cbd">
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">CBD</label>
                                <div class="flex flex-row rounded bg-gray-black ">
                                    <span class="mt-1 ml-2">{{form.concentration_unit}}</span>
                                    <input v-model.number="form.cbd" placeholder="20.5" class="block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                </div>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                    <!-- thc_cbd_value_type is not set or thc_cbd_value_type is range -->
                    <div class="w-full xl:w-2/3" >
                        <div class="input-wrapper">
                            <label class="text-xs">CBD (Range)</label>
                            <div class="flex">
                                <div class="relative w-full">
                                    <Field v-slot="{field, errors, errorMessage}" name="cbd_min" v-model.number="form.cbd_min">
                                        <div class="flex flex-row rounded bg-gray-black ">
                                            <span class="mt-1 ml-1">{{form.concentration_unit}}</span>
                                            <input v-model.number="form.cbd_min" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                        </div>
                                        <div v-if="errors.length>0" class="text-xs" :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                        <div v-else class="text-xs">&nbsp;</div>
                                    </Field>
                                </div>
                                <span class="flex items-center mx-1">
                                    <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                                    </svg>
                                </span>
                                <div class="relative w-full">
                                    <Field v-slot="{field, errors, errorMessage}" name="cbd_max" v-model.number="form.cbd_max">
                                        <div class="flex flex-row rounded bg-gray-black ">
                                            <span class="mt-1 ml-1">{{form.concentration_unit}}</span>
                                            <input v-model.number="form.cbd_max" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                        </div>
                                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                        <div v-else class="text-xs">&nbsp;</div>
                                    </Field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-start mb-3">
                    <div class="w-full">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="description" v-model="form.description" >
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">Description</label>
                                <textarea v-bind="field" id="message" rows="4" class="block rounded border-none p-2.5 w-full text-sm bg-gray-black placeholder-theme-878686" placeholder=""></textarea>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
                <div class="flex items-start mb-3">
                    <div class="w-full">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="longDescription" v-model="form.longDescription" >
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">Long Description</label>
                                <textarea v-bind="field" id="message" rows="4" class="block rounded border-none p-2.5 w-full text-sm bg-gray-black placeholder-theme-878686" placeholder=""></textarea>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
                <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                    <div class="w-full xl:w-1/2">
                        <div class="input-wrapper">
                            <label class="text-xs">Drying Method</label>
                            <input v-model="form.drying_method" placeholder="" class="block tracking-wider border-none rounded text-sm bg-gray-black w-full h-[36px] px-2 focus:outline-0 placeholder-theme-878686">
                        </div>
                        <div class="input-wrapper mt-2">
                            <label class="text-xs">Growing Province</label>
                            <input v-model="form.growing_province" placeholder="" class="block tracking-wider border-none rounded text-sm bg-gray-black w-full h-[36px] px-2 focus:outline-0 placeholder-theme-878686">
                        </div>
                        <div class="input-wrapper mt-2">
                            <label class="text-xs">Grow Room Lighting</label>
                            <input v-model="form.grow_room_lighting" placeholder="" class="block tracking-wider border-none rounded text-sm bg-gray-black w-full h-[36px] px-2 focus:outline-0 placeholder-theme-878686">
                        </div>
                        <div class="input-wrapper mt-2">
                            <label class="text-xs">Grow Medium</label>
                            <input v-model="form.grow_medium" placeholder="" class="block tracking-wider border-none rounded text-sm bg-gray-black w-full h-[36px] px-2 focus:outline-0 placeholder-theme-878686">
                        </div>
                        <div class="input-wrapper mt-2">
                            <label class="text-xs">Growing Method</label>
                            <input v-model="form.growing_method" placeholder="" class="block tracking-wider border-none rounded text-sm bg-gray-black w-full h-[36px] px-2 focus:outline-0 placeholder-theme-878686">
                        </div>
                        <div class="input-wrapper mt-2">
                            <label class="text-xs">Growing Region</label>
                            <input v-model="form.growing_region" placeholder="" class="block tracking-wider border-none rounded text-sm bg-gray-black w-full h-[36px] px-2 focus:outline-0 placeholder-theme-878686">
                        </div>
                    </div>
                    <div class="w-full xl:w-1/2">
                        <div class="input-wrapper">
                            <LicenseProducer placeholder="Enter LP here" v-model="form.licensedProducer" className="h-9" iconClass="mt-2" />
                        </div>
                        <div class="input-wrapper mt-2">
                            <label class="text-xs">Extraction Process</label>
                            <input v-model="form.extraction_process" placeholder="" class="block tracking-wider border-none rounded text-sm bg-gray-black w-full h-[36px] px-2 focus:outline-0 placeholder-theme-878686">
                        </div>
                        <div class="input-wrapper mt-2">
                            <label class="text-xs">Trimming Method</label>
                            <input v-model="form.trimming_method" placeholder="" class="block tracking-wider border-none rounded text-sm bg-gray-black w-full h-[36px] px-2 focus:outline-0 placeholder-theme-878686">
                        </div>
                        <div class="mt-2">
                            <label class="block text-white text-sm">Image</label>
                            <div class="flex items-center justify-between">
                                <file-manager v-model="form.image" classes="bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest" label="SELECT" >
                                    <template v-slot:custom="{ onClick }">
                                        <div class="flex flex-row justify-between mt-1">
                                        <div class="content-image  w-[calc(100%-116px)] w-[400px] h-[100px] my-auto" v-if="form.image">
                                            <img class="p-1 min-w-[50px] min-h-[50px] w-full" :src="form.image" />
                                        </div>
                                        <div v-else class="text-[#878686] text-sm tracking-wider">Not Assigned</div>
                                        <div @click="onClick" class="h-9 bg-white text-center w-[100px] hover:bg-[#2BA66B] hover:text-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest">{{ form.image ? 'CHANGE' : 'SELECT'}}</div></div>
                                    </template>
                                </file-manager>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </div>    
    </div>
</template>
<script>
import debounce from 'lodash/debounce'
import Helpers from '@/helpers';
import {mapGetters, mapMutations} from 'vuex'
import {Form, Field} from 'vee-validate'
import SelectCheckbox from '@/components/form/SelectCheckbox.vue'
import SelectSearchBrand from '@/components/form/SelectSearchBrand'
import { ref, defineComponent } from 'vue'
import ProductApi from '@/controllers/BusinessProductApis'
import { useSnackbar } from "vue3-snackbar"
import StringHelper from '@/helpers/string'
import FileManager from '@/components/manager/filemanager.vue'
import LicenseProducer from '@/components/form/LicenseProducer'

export default defineComponent({
    props: ['editItem', 'brands'],
    components: {
        Form,
        Field,
        SelectCheckbox,
        SelectSearchBrand,
        FileManager,
        LicenseProducer
    },
    setup() {
        const snackbar = useSnackbar();
    
        const form = ref({
            name: '',
            complianceProvider: '',
            brand_id: '',
            strain: '',
            tax: '',
            complianceType: '',
            stock: '',
            stock_threshold: '',
            sku: '',
            gtin: '',
            concentration_unit: '',
            size: '',
            price: '',
            weight_equivalent_dry_cannabis: '',
            description: '',
            longDescription: '',
            thc_cbd_value_type: '',
            thc: '',
            thc_min: '',
            thc_max: '',
            cbd: '',
            cbd_min: '',
            cbd_max: '',
            image: '',
            drying_method: '',
            growing_province: '',
            grow_room_lighting: '',
            grow_medium: '',
            trimming_method: '',
            licensedProducer: '',
            extraction_process: '',
            growing_method: '',
            growing_region: ''
        })
        const schema = {
            name: 'required',
            strain: 'required',
            complianceType: 'required',
            brand_id: 'required',
            gtin: 'required',
            size: 'required',
            weight_equivalent_dry_cannabis: 'required',
            sku: 'required|max:100',
            thc: 'price',
            thc_min: 'price',
            thc_max: 'price',
            cbd: 'price',
            cbd_min: 'price',
            cbd_max: 'price'
        }
        const accessorySchema= {
            name: 'required',
            complianceType: 'required',
            brand_id: 'required',
            gtin: 'required',
            size: 'required',
            sku: 'required|max:100',
            thc: 'price',
            thc_min: 'price',
            thc_max: 'price',
            cbd: 'price',
            cbd_min: 'price',
            cbd_max: 'price'
        }

        let complianceList = ['Dried flower','Pre rolled','Extracts ingested','Extracts inhaled','Edibles solids','Edibles non-solids','Topicals','Accessory']
        let plantTypes = ['sativa', 'indica', 'hybrid', 'blend']
        let complianceProviders = ['ocs', 'aglc', 'mbll']

        return {snackbar, form, schema, accessorySchema, complianceList, plantTypes, complianceProviders}
    },
    async mounted() {
        this.form = _.pick(this.editItem, ['name', 'brand_id', 'strain', 'sku', 'gtin', 'size', 'price', 'weight_equivalent_dry_cannabis', 
            'concentration_unit', 'thc_cbd_value_type', 'thc', 'thc_min', 'thc_max', 'cbd', 'cbd_min', 'cbd_max', 'description', 'longDescription', 'image',
            'drying_method', 'growing_province', 'grow_room_lighting', 'grow_medium', 'trimming_method', 'extraction_process', 
            'growing_method', 'growing_region'])
        this.form.complianceProvider = this.editItem.complianceProvider?this.editItem.complianceProvider.toLowerCase():''
        this.form.licensedProducer = this.editItem.producer?.licensedProducer?this.editItem.producer?.licensedProducer:''
        this.form.complianceType = StringHelper.capitalize(this.editItem.complianceType)
        this.emitter.on("saveEditProduct", this.submit);
    },
    unmounted(){
        this.emitter.off("saveEditProduct", this.submit)
    },
    beforeDestroy() {
        this.emitter.off("saveEditProduct", this.submit)
    },
    watch: {
        async editItem(item){
            this.form = _.pick(this.editItem, ['name', 'brand_id', 'strain', 'sku', 'gtin', 'size', 'price', 'weight_equivalent_dry_cannabis', 
                'concentration_unit', 'thc_cbd_value_type', 'thc', 'thc_min', 'thc_max', 'cbd', 'cbd_min', 'cbd_max', 'description', 'longDescription', 'image',
                'drying_method', 'growing_province', 'grow_room_lighting', 'grow_medium', 'trimming_method','extraction_process', 
                'growing_method', 'growing_region'])
            this.form.complianceProvider = this.editItem.complianceProvider?this.editItem.complianceProvider.toLowerCase():''
            this.form.licensedProducer = this.editItem.producer?.licensedProducer?this.editItem.producer?.licensedProducer:''
            this.form.complianceType = StringHelper.capitalize(this.editItem.complianceType)
            this.emitter.on("saveEditProduct", this.submit);
        }
    },
    computed: {
        categoryColor: function() {
            if(this.form.categoryId){
                let currentCategory = this.categories.filter(each => each.id == this.form.categoryId)
                if(currentCategory[0]?.posColour)
                    return currentCategory[0].posColour
                else
                    return 'black'
            }else{
                return 'black'
            }
        },
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected'
        })
    },
    methods: {
        getSchema(type){
            if(type=='Accessory'){
                return this.accessorySchema
            }else{
                return this.schema
            }
        },
        labelClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }else if(value){
                return 'text-theme-green'
            }
        },
        inputClass(value, error){
            if(value && error){
                return 'border-theme-red'
            }else if(error){
                return 'border-theme-orange'
            }else if(value){
                return 'border-theme-green'
            }
        },
        errorClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }
        },
        submit: debounce(async function(){
            this.vm_spinner(true)
            let data = {...this.form}
            data.product_name = this.editItem.product_name
            data.weight_equivalent_dry_cannabis  = parseFloat(data.weight_equivalent_dry_cannabis)
            let res = await ProductApi.updateMasterProduct(this.editItem.id, data)
            this.snackbar.add({
                type: 'info',
                text: res.status == 200 ? "Product updated successfully." : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            this.vm_spinner(false)
            if(res.status==200){
                this.emitter.emit("closeAddEdit")
                this.emitter.emit("reloadProductList")
            }
        }, 600),
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>